export const truncate = (value: string, num: number): string => {
    if (value.length <= num || num <= 0) {
        return value;
    }

    return value.slice(0, num) + '...';
}

export const getAttributeValue = (el: Element, attr: string, toJson: boolean = false): string | undefined | {} => {
    let foundAttr = el.attributes.getNamedItem(attr);

    if (foundAttr && foundAttr.value) {
        return foundAttr && foundAttr.value ? (toJson ? JSON.parse(foundAttr.value) : foundAttr.value) : '';
    }
}

export const isInParent = (element: Element): boolean => {
    var bounding: DOMRect = element.getBoundingClientRect();
    var parent: HTMLElement = element.parentElement as HTMLElement;
    var parentBounding: DOMRect = parent.getBoundingClientRect();

    return  bounding.top >= (parentBounding.top - 2) &&
            bounding.bottom <= (parentBounding.bottom + 2)
}

export const bottomIsInParent = (element: Element): boolean => { 
    var bounding = element.getBoundingClientRect(); 
    var parent: HTMLElement = element.parentElement as HTMLElement; 
    var parentbottom = parent.getBoundingClientRect().bottom;
    var childBottom = bounding.bottom; 

    return (parentbottom >= childBottom); 
} 

export const isInViewport = (element: Element): boolean => {
    var bounding = element.getBoundingClientRect();
    var width: number = window.innerWidth || document.documentElement.clientWidth; 
    var height: number = window.innerHeight || document.documentElement.clientHeight;

    return (
        bounding.top >= 0 &&
        (bounding.left >= 0 || bounding.left <= width) &&
        bounding.top <= height &&
        (bounding.right <= width ||
        bounding.left <= width)
    );
}

export const findAncestor = (el: any, cls: string): any => {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}

export const formatString = (label: string, args: []): string => {
    if(!label) {
        return '';
    }

    return label.replace(/{(\d+)}/g, (match, number) => { 
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
}